import { Grade } from '@/Module/Workspace/Model/Enum';

export const GRADE_NAMES: Record<Partial<Grade>, string> = {
  [Grade.AVAL]: 'اول',
  [Grade.DOVOM]: 'دوم',
  [Grade.SEVOM]: 'سوم',
  [Grade.CHAHAROM]: 'چهارم',
  [Grade.PANJOM]: 'پنجم',
  [Grade.SHISHOM]: 'ششم',
  [Grade.HAFTOM]: 'هفتم',
  [Grade.HASHTOM]: 'هشتم',
  [Grade.NOHOM]: 'نهم',
  [Grade.DAHOM]: 'دهم',
  [Grade.YAZDAHOM]: 'یازدهم',
  [Grade.DAVAZDAHOM]: 'دوازدهم',
  [Grade.SHISHOM_TIZHOUSHAN]: 'ششم',
  [Grade.NOHOM_TIZHOUSHAN]: 'نهم',
  [Grade.DAHOM_KONKOUR]: 'دهم',
  [Grade.DAHOM_NAHAEI]: 'دهم',
  [Grade.YAZDAHOM_KONKOUR]: 'یازدهم',
  [Grade.YAZDAHOM_NAHAEI]: 'یازدهم',
  [Grade.DAVAZDAHOM_KONKOUR]: 'دوازدهم',
  [Grade.DAVAZDAHOM_NAHAEI]: 'دوازدهم',
};
